import { createServerOnlyFn } from "@tanstack/react-start";
import {
    handleChatgptDogSearchRequest,
    handleWagsMcpMetadataRequest,
} from "./run.server";

const handleMcpRequest = createServerOnlyFn(
    ({ request }: { request: Request }) =>
        handleChatgptDogSearchRequest(request),
);

export const mcpApiRoute = {
    server: {
        handlers: {
            POST: handleMcpRequest,
            GET: handleMcpRequest,
            DELETE: handleMcpRequest,
        },
    },
};

const handleMetadataRequest = createServerOnlyFn(
    ({ request }: { request: Request }) =>
        handleWagsMcpMetadataRequest(request),
);

export const mcpProtectedResourceMetadataRoute = {
    server: {
        handlers: {
            GET: handleMetadataRequest,
        },
    },
};
